import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
var hasUnsavedChanges = false;
var NEW_SLT_CONTENT = "To save your changes, complete the kit and sample information in sections 1 & 2 of the sample loading table, then click 'Save to Trailmaker'.";
var EXISTING_SLT_CONTENT = "To save your changes, click 'Save to Trailmaker' after section 2.";
var hasPersistedWorksheetState = function hasPersistedWorksheetState(sampleLoadingTable) {
  var _sampleLoadingTable$s;
  return Boolean(sampleLoadingTable === null || sampleLoadingTable === void 0 || (_sampleLoadingTable$s = sampleLoadingTable.samplesData) === null || _sampleLoadingTable$s === void 0 ? void 0 : _sampleLoadingTable$s.length);
};
var getDiscardUnsavedChangesCopy = function getDiscardUnsavedChangesCopy(sampleLoadingTable) {
  return {
    title: 'You have unsaved changes.',
    content: hasPersistedWorksheetState(sampleLoadingTable) ? EXISTING_SLT_CONTENT : NEW_SLT_CONTENT
  };
};
var setSltUnsavedChanges = function setSltUnsavedChanges(value) {
  hasUnsavedChanges = Boolean(value);
};
var getSltUnsavedChanges = function getSltUnsavedChanges() {
  return hasUnsavedChanges;
};
var FORMULA_UPDATE_TITLE = 'Update sample loading table calculations';
var FORMULA_UPDATE_CONTENT = 'The underlying formulae for the v4 chemistry sample loading ' + "table has been updated. Click 'Update' to apply the new formulae to your " + 'sample loading table.';

// Resolves 'update' or 'discard'; forces a choice (no accidental dismissal).
var confirmFormulaUpdate = function confirmFormulaUpdate() {
  return new Promise(function (resolve) {
    _Modal.confirm({
      title: FORMULA_UPDATE_TITLE,
      content: FORMULA_UPDATE_CONTENT,
      okText: 'Update',
      okButtonProps: {
        type: 'primary'
      },
      cancelText: 'Discard changes',
      cancelButtonProps: {
        danger: true
      },
      keyboard: false,
      onOk: function onOk() {
        return resolve('update');
      },
      onCancel: function onCancel() {
        return resolve('discard');
      }
    });
  });
};
var confirmDiscardUnsavedChanges = function confirmDiscardUnsavedChanges(sampleLoadingTable) {
  return new Promise(function (resolve) {
    if (!hasUnsavedChanges) {
      resolve(true);
      return;
    }
    var _getDiscardUnsavedCha = getDiscardUnsavedChangesCopy(sampleLoadingTable),
      title = _getDiscardUnsavedCha.title,
      content = _getDiscardUnsavedCha.content;
    _Modal.confirm({
      title: title,
      content: content,
      okText: 'Discard changes',
      okButtonProps: {
        danger: true
      },
      cancelText: 'Cancel',
      onOk: function onOk() {
        // User explicitly chose to discard — reset so the next check doesn't re-prompt.
        hasUnsavedChanges = false;
        resolve(true);
      },
      onCancel: function onCancel() {
        return resolve(false);
      }
    });
  });
};
export { setSltUnsavedChanges, getSltUnsavedChanges, confirmDiscardUnsavedChanges, confirmFormulaUpdate, getDiscardUnsavedChangesCopy, FORMULA_UPDATE_TITLE, FORMULA_UPDATE_CONTENT };